/**
 * Enumeration containing popular colors
 * @enum {string}
 */
var NAMED_COLORS = {
    'white': 0xFFFFFFff,
    'black': 0x000000ff,
    'red'  : 0xFF0000ff,
    'green': 0x00FF00ff,
    'blue' : 0x0000FFff,
    'transparent':0x00000000
}

module.exports = NAMED_COLORS;



//////////////////
// WEBPACK FOOTER
// ./node_modules/pureimage/src/named_colors.js
// module id = m89j
// module chunks = 0